import { zeusApi } from 'src/store/api';
import { type Admin, type CreateAdminPayload, type EditAdminArgs, type OwnMembership } from 'src/shared/types/admin';

// TODO: replace with the shared CustomErrorArg
type GetMePayload = {
  isCustomError: true;
};

type ResetAdminPasswordPayload = {
  email: string;
};

const extendedApi = zeusApi.injectEndpoints({
  endpoints: build => ({
    getAdmins: build.query<Admin[], void>({
      query: () => ({
        url: '/admin',
        method: 'GET'
      }),
      transformResponse: (response: { data: Admin[] }) => response.data,
      providesTags: ['Admin']
    }),
    getMe: build.query<OwnMembership, GetMePayload>({
      query: () => ({
        url: '/me',
        method: 'GET'
      }),
      transformResponse: (response: { data: OwnMembership }) => response.data
    }),
    createAdmin: build.mutation<{ email: string }, CreateAdminPayload>({
      query: data => ({
        url: '/admin',
        method: 'POST',
        body: data
      }),
      transformResponse: (response: { data: { email: string } }) => response.data,
      invalidatesTags: ['Admin']
    }),
    editAdmin: build.mutation<undefined, EditAdminArgs>({
      query: ({ adminId, membership }) => ({
        url: `/admin/${adminId}`,
        method: 'PUT',
        body: membership
      }),
      invalidatesTags: ['Admin']
    }),
    deleteAdmin: build.mutation<undefined, string>({
      query: adminId => ({
        url: `/admin/${adminId}`,
        method: 'DELETE'
      }),
      invalidatesTags: ['Admin']
    }),
    resetAdminPassword: build.mutation<undefined, ResetAdminPasswordPayload>({
      query: data => ({
        url: '/admin/reset-password',
        method: 'POST',
        body: data
      })
    })
  }),
  overrideExisting: false
});

export const {
  useGetAdminsQuery,
  useGetMeQuery,
  useCreateAdminMutation,
  useEditAdminMutation,
  useDeleteAdminMutation,
  useResetAdminPasswordMutation
} = extendedApi;
